<template>
  <CockpitDialog
    :title="title"
    left="360px"
    width="1200px"
    height="700px"
    top="120px"
    @close="$emit('close')"
  >
    <!-- <el-table
      :data="tableData"
      highlight-current-row
      class="!h-[calc(100%-132px)] !w-full"
      ref="tableRef"
      v-loading="tableLoading"
    >
      <el-table-column label="序号" type="index" width="60" :index="indexMethod"> </el-table-column>
      <el-table-column
        v-for="(item, index) in tableColumns"
        :key="index"
        :label="item.label"
        :width="item.width"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div
            v-if="item.type === 'ThreeDimensional'"
            @click="moveThreeD(scope.row)"
            class="cursor-pointer text-hex-00bcc8 truncate"
          >
            {{ scope.row[item.prop] }}
          </div>
          <div v-else class="truncate">
            {{ scope.row[item.prop] }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="{ row }">
          <div @click="lookDetail(row)" class="cursor-pointer text-hex-00bcc8">查看</div>
        </template>
      </el-table-column>
    </el-table> -->
    <iframe class="w-full h-full" :src="iframeUrl"></iframe>
  </CockpitDialog>
</template>

<script>
import CockpitDialog from '@/components/cockpit/CockpitDialog'
// metal default data
import { detailsConfig } from './config'

const { config } =
  Wiz.globalSettings.dynamicModules.modules['visualization-tongre-vulkan'].config.cockpitDyw

export default {
  data() {
    return {
      data: {},
      mockData: {
        code: 0,
        message: '操作成功',
        data: {
          currTicket: {
            id: '1406886904238067714',
            createId: '1278479637633183746',
            createTime: '2021-06-21T08:09:11.323570Z',
            lastModifyId: '1278479637633183746',
            lastModifyTime: '2021-06-22T03:29:19.653728Z',
            title: null,
            taskName: '测试操作票062201',
            taskNo: null,
            serialNo: null,
            state: 'WaitCommit',
            stateDescription: '待提交',
            beginTime: null,
            endTime: null,
            riskLevel: 'Low',
            remark: null,
            workflowId: null,
            hasPermission: false,
            formKey: null,
            isSinglePersonOperation: false,
            ticketType: null,
            ticketTypeName: null,
            profession: null,
            workgroup: null,
            department: null,
            ppeCheck: null,
            ppeCheckTime: null,
            ticketTaskPersonas: [],
            ticketRatePersonas: null,
            allTicketTaskPersonas: [
              {
                roleType: 'Operator',
                roleTypeName: '操作人',
                step: 1,
              },
              {
                roleType: 'Guardian',
                roleTypeName: '监护人',
                step: 2,
              },
              {
                roleType: 'Approver',
                roleTypeName: '值长',
                step: 3,
              },
            ],
            handOnBoardCount: 0,
            handOnCommonLockCount: 0,
            deviceInfo: {
              lockCabinetList: null,
              wireCabinetList: null,
            },
            fileList: [],
            dataSourceFrom: null,
            commandTime: null,
            commandCommander: null,
            commandReceiver: null,
            reportTime: null,
            reportCommander: null,
            reportReceiver: null,
            ticketCreateTime: '2021-06-21T08:09:11.323442Z',
            ticketItemCount: 3,
            ticketItemFinishedCount: 0,
            useScope: null,
            commandFrom: null,
            planBeginTime: null,
            planEndTime: null,
            commitTime: null,
            approveTime: null,
            isFinished: false,
            boardInfoList: null,
            hasExpired: null,
            deviceAreaList: [
              {
                deviceAreaId: '1337573194558619650',
                deviceAreaName: '优特科技大厦',
                handOnCommonLockInfoList: null,
              },
            ],
          },
          currTicketItemList: [
            {
              id: '1406886904263233537',
              createId: '1278479637633183746',
              createTime: '2021-06-21T08:09:11.328724Z',
              lastModifyId: null,
              lastModifyTime: null,
              ticketId: '1406886904238067714',
              sortId: 1,
              text: '提示项1',
              operationMode: 'HintTip',
              operationModeName: '提示项操作',
              fromState: null,
              toState: null,
              deviceId: null,
              deviceBoardId: null,
              operationTermId: null,
              subOperateMode: null,
              operationTime: null,
              realOperationMode: null,
              finishTime: null,
              isFinished: null,
              remark: null,
              uid: null,
              identifier: null,
              cabinetId: null,
              cabinetName: null,
              buckleName: null,
              preview: null,
              previewTime: null,
              fileList: [],
              signatureList: [],
              measureValueList: [],
              itemWaitApproveInfoList: [],
              textDisplay: null,
              deviceName: null,
              bindDeviceId: null,
              actualBindDeviceId: null,
              bindDeviceTime: null,
              bindDeviceFlag: null,
              deviceLockInfo: null,
              voltage: null,
              deviceAreaId: null,
              deviceIdentifier: null,
              others: null,
              executable: null,
            },
            {
              id: '1406886904259039237',
              createId: '1278479637633183746',
              createTime: '2021-06-21T08:09:11.328461Z',
              lastModifyId: null,
              lastModifyTime: null,
              ticketId: '1406886904238067714',
              sortId: 2,
              text: '退出压板测试压板004',
              operationMode: 'Normal',
              operationModeName: '正常操作',
              fromState: 1,
              toState: 0,
              deviceId: '1402236649022230529',
              deviceBoardId: null,
              operationTermId: '1402868027732586498',
              subOperateMode: 'DismantlePressPlate',
              operationTime: null,
              realOperationMode: null,
              finishTime: null,
              isFinished: null,
              remark: null,
              uid: null,
              identifier: null,
              cabinetId: null,
              cabinetName: null,
              buckleName: null,
              preview: null,
              previewTime: null,
              fileList: [],
              signatureList: [],
              measureValueList: [],
              itemWaitApproveInfoList: [],
              textDisplay: null,
              deviceName: 'csyb004',
              bindDeviceId: null,
              actualBindDeviceId: null,
              bindDeviceTime: null,
              bindDeviceFlag: null,
              deviceLockInfo: {
                lockInfoId: '1402236649034813442',
                version: 1,
                lockNumber: 'Um1',
                lockNumberName: '锁码位置1',
                lockNumberValue: 1,
                lockType: 'ZNYB',
                lockTypeName: '智能压板',
                lockTypeValue: 11,
                code: '008048ACC0CC',
                ekeyProperty: 'NoKey',
                ekeyPropertyName: '未选择锁具属性',
                ekeyPropertyValue: 255,
              },
              voltage: null,
              deviceAreaId: '1337573194558619650',
              deviceIdentifier: '',
              others: null,
              executable: null,
            },
            {
              id: '1406886904259039236',
              createId: '1278479637633183746',
              createTime: '2021-06-21T08:09:11.328243Z',
              lastModifyId: null,
              lastModifyTime: null,
              ticketId: '1406886904238067714',
              sortId: 3,
              text: '提示项2',
              operationMode: 'HintTip',
              operationModeName: '提示项操作',
              fromState: null,
              toState: null,
              deviceId: null,
              deviceBoardId: null,
              operationTermId: null,
              subOperateMode: null,
              operationTime: null,
              realOperationMode: null,
              finishTime: null,
              isFinished: null,
              remark: null,
              uid: null,
              identifier: null,
              cabinetId: null,
              cabinetName: null,
              buckleName: null,
              preview: null,
              previewTime: null,
              fileList: [],
              signatureList: [],
              measureValueList: [],
              itemWaitApproveInfoList: [],
              textDisplay: null,
              deviceName: null,
              bindDeviceId: null,
              actualBindDeviceId: null,
              bindDeviceTime: null,
              bindDeviceFlag: null,
              deviceLockInfo: null,
              voltage: null,
              deviceAreaId: null,
              deviceIdentifier: null,
              others: null,
              executable: null,
            },
          ],
          riskItemList: [
            {
              id: '1407178862722437121',
              workSequence: null,
              dangerSource: '风险描述',
              workStandard: '控制措施',
              sortId: 1,
              riskLevel: null,
              isFinished: null,
              operationTime: null,
              ticketId: '1406886904238067714',
              riskItemTemplateId: null,
              dangerFactor: null,
              dangerResult: null,
            },
          ],
          riskPromptList: [],
          ticketPPEList: [],
          wtTicketBaseInfoDtoList: [],
          workTicketOutputList: [],
          taskLockControlInfo: null,
          toolTicketRelationGroupList: [],
        },
        success: true,
      },
    }
  },
  methods: {
    async getDetails() {
      this.tableLoading = true
      // const res = await axios.get(`${config.url}${detailsConfig.pipelineSecondaryLedger.api}`, {
      //   headers: {
      //     'Content-Type': 'application/json',
      //     'org-id': config.orgId,
      //     'token-id': config.tokenId,
      //   },
      // })

      axios({
        method: 'GET',
        url: `${config.url}${detailsConfig.pipelineSecondaryLedger.api}?id=${this.id}`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
          'org-id': config.orgId,
          'token-id': config.tokenId,
        },
        responseType: 'json',
      })
        .then((res) => {
          this.tableData = res.data.currTicketItemList
        })
        .then((err) => {
          console.log(err)
        })
      this.tableLoading = false
      // const [err, data] = await metalbimapi[this.searchApi](this.page.pageNo, this.page.pageSize, {
      //   keyWord: this.metalBimChildKeyword,
      //   metalType: '管道二级台账',
      // })
      // if (!err && data) {
      //   this.tableData = _.map(data.items, (item) => {
      //     return {
      //       ...item,
      //       PrGroupType: this.transferProps.prGroupType,
      //       PrName: this.transferProps.prName,
      //       prCode: item.prCode,
      //       prName: item.prName,
      //     }
      //   })
      //   this.page.total = data.totalCount
      //   this.tableLoading = false
      // }
    },
    // download(file) {
    //   const metalUrl = _.get(
    //     Wiz,
    //     'globalSettings.dynamicModules.modules["visualization-tongre-vulkan"].config.metalUrl'
    //   )
    //   window.location.href = `${metalUrl}${file.url}`
    // },
    // dealFileList(val) {
    //   if (val) {
    //     // 判断多个附件(,) 还是单个附件 返回字段包含 ','
    //     const multipleAttachments = _.includes(val, ',')
    //     if (multipleAttachments) {
    //       const multipleArr = _.split(val, ',')
    //       return _.map(multipleArr, (item) => {
    //         return {
    //           name: _.split(item, 'name=').pop(),
    //           url: item,
    //         }
    //       })
    //     }
    //     return new Array({ name: _.split(val, 'name=').pop(), url: val })
    //   }
    //   return []
    // },
  },
  computed: {
    tableColumns() {
      return detailsConfig.pipelineSecondaryLedger.tableHead
    },
  },
  components: {
    CockpitDialog,
  },
  props: {
    // 标题
    title: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    iframeUrl: {
      type: String,
      default: '',
    }
  },
  created() {
    // console.log(Wiz.globalSettings.api.endpoints['cockpit-dyw'])
    // this.getDetails()
  },
  watch: {
    id: {
      handler() {
        this.getDetails()
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-upload {
  display: none !important;
}
::v-deep .el-upload-list__item:hover {
  background-color: transparent !important;
}
::v-deep .el-upload-list__item.is-success .el-upload-list__item-name:hover {
  color: #00ffcf;
}
::v-deep .el-upload-list__item .el-icon-upload-success {
  color: #47c1aa;
}
::v-deep .el-upload-list__item-name {
  color: #47c1aa;
}
</style>
